module.exports = __webpack_public_path__ + "static/media/per_hour_icon.fb28419f.png";